var $header = jQuery(".js-header-box"),
  headerO = $header.offset(),
  headerH = $header.outerHeight(),
  hash = window.location.hash,
  href = window.location.href,
  $adminbar = jQuery("#wpadminbar"),
  barH = "0"

const fixHeader = function () {
  if (jQuery(window).scrollTop() > 1) {
    $header.addClass("sticky-header")
  } else {
    $header.removeClass("sticky-header")
  }
  if (jQuery(window).scrollTop() > headerO.top + headerH) {
    $header.addClass("small-header")
  } else {
    $header.removeClass("small-header")
  }
}

const headerHeight = function () {
  const headerH = $header.outerHeight()
  jQuery(".site-header").height(headerH)
  jQuery(".site-header-style2").height(headerH)
}

// const inputForm = function () {
//   jQuery('.input').on('blur', function () {
//     if (jQuery(this).value != 0) {
//       jQuery(this).addClass('input-filled')
//     } else {
//       jQuery(this).removeClass('input-filled')
//     }
//   })
// }

const bodyAnimate = function () {
  if ($adminbar.length) {
    barH = $adminbar.outerHeight()
  }
}

// faq accordion
const faqAccordion = function () {
  jQuery(".wp-block-yoast-faq-block").addClass("fcp-faq")
  jQuery(".wp-block-yoast-faq-block .schema-faq-question").click(function () {
    jQuery(this).parent().toggleClass("fcp-opened")
  })
}

// forms
const forms = function () {
  /*********************************************
   ** FLOATING LABELS FOR CF7
   *********************************************/
  jQuery(".wpcf7 .form-control")
    .focus(function () {
      jQuery(this).closest(".form-group").addClass("active")
    })
    .blur(function () {
      var cval = jQuery(this).val().trim().length
      if (cval === 0) {
        jQuery(this).closest(".form-group").removeClass("active")
      }
    })

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      // console.log(event.detail.contactFormId)
      if (9 === event.detail.contactFormId || 1073 === event.detail.contactFormId) {
        var customResponseOutput = jQuery("#contactModalThanks")

        console.log(customResponseOutput)
        var $contactSection = jQuery(".contact-section")
        var $servicesContact = jQuery(".services-contact")
        if ($contactSection.length > 0) {
          $contactSection
            .addClass("success")
            .append(customResponseOutput)
            .find(".wp-block-column")
            .fadeOut(10)
          jQuery(".contact-section__success").delay(1500).fadeIn(1000)
          customResponseOutput.delay(1500).removeClass("hide")
        }
        if ($servicesContact.length > 0) {
          $servicesContact
            .addClass("success")
            .append(customResponseOutput)
            .find(".wp-block-column")
            .fadeOut(500)
          jQuery(".contact-section__success").delay(500).fadeIn(100)
        }
      }
    },
    false
  )

  function handleCloseButtonClick(e) {
    e.preventDefault()
    jQuery(".contact-section__success").remove()
    jQuery(".contact-section, .services-contact")
      .removeClass("success")
      .find(".wp-block-column")
      .fadeIn(500)
    jQuery("#simplemodal_close").click()
  }

  jQuery(document).on(
    "click",
    ".contact-section__success .simplemodal-close",
    handleCloseButtonClick
  )

  jQuery(document).on("input change keyup", ".sf-field-search .sf-input-text", function ($) {
    var searchInput = jQuery(this)
    var elementToHide = jQuery(".sf-field-reset")

    if (searchInput.val().length > 0) {
      elementToHide.show()
    } else {
      elementToHide.hide()
    }
  })
}

// const copyLink = function ($id) {
//   /* Get the text field */
//   const copyText = document.getElementById($id)

//   /* Select the text field */
//   copyText.select()
//   copyText.setSelectionRange(0, 99999) /* For mobile devices */

//   /* Copy the text inside the text field */
//   document.execCommand('copy')

//   //jQuery(copyText).nextAll('a').addClass('has-teal-600-color').find('.text').html('Link Copied')

//   /* Alert the copied text */
//   // alert("Copied the text: " + copyText.value);
// }

jQuery(window).load(function ($) {
  headerHeight()
})

jQuery(window).scroll(function ($) {
  fixHeader()
})

jQuery(window).resize(function ($) {
  headerHeight()
})

// Wait for document ready
jQuery(document).ready(function ($) {
  // Run this function when AJAX is finished.
  function hideReset() {
    // Show or Hide Reset Button on SF Search Input Change
    var empty = true
    $(".sf-field-search input").each(function () {
      if ($(this).val()) {
        empty = false
      }
    })
    if (empty) {
      $(".sf-field-reset").hide()
    } else {
      $(".sf-field-reset").show()
    }
  }

  // Listen for SF AJAX events
  $(document).on("sf:ajaxfinish", function (event) {
    hideReset()
  })
})

jQuery(document).ready(function ($) {
  // $('select').niceSelect()
  headerHeight()
  fixHeader()
  bodyAnimate()
  faqAccordion()
  forms()

  var control = ".wpcf7 .form-control"

  if (jQuery(control).length > 0) {
    jQuery(document).on("focus blur", control, function (event) {
      // Use event.target instead of jQuery(this) for better performance
      var $parent = jQuery(event.target).closest(".form-group")
      if (event.type === "focus") {
        $parent.addClass("active")
      } else {
        var cval = event.target.value.trim().length
        if (cval === 0) {
          $parent.removeClass("active")
        }
      }
    })
  }

  $(".wpcf7-select").on("click change input", function () {
    var selectedOption = $(this).find(":selected")
    var $formControlWrap = $(this).closest(".wpcf7-form-control-wrap")
    if ($(this).is(":visible")) {
      $formControlWrap.addClass("open")
    } else {
      $formControlWrap.removeClass("open")
    }
  })
  // $(function () {
  // var video = $('video')
  // var targetElement = $('#impact-wrapper-block_6490794436831') // replace with the ID or class of the element you want to append the button to
  // if (video.length > 0 && targetElement.length > 0) {
  //   targetElement.append('<button id="playvideo">Play Video</button>')

  //   document.addEventListener('click', function (event) {
  //     var video = document.querySelectorAll('.wp-block-cover__background')
  //     if (event.target.id === 'playvideo') {
  //       console.log(video)
  //       video.play()
  //     }
  //   })

  //   $('#playvideo').click()
  // }
  // })
})
